import { Box, Typography } from '@mui/material';

const currentYear = new Date().getFullYear();

/**
 * Componente de rodapé fixo na parte inferior da página.
 * Exibe informações de copyright e créditos.
 * 
 * @component
 * @returns {JSX.Element} Footer fixo com informações de copyright
 */
function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 48,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: '#6b38363a',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, md: 4 },
        zIndex: 50
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' } }}
      >
        © {currentYear} Vika Cosméticos
      </Typography>
    </Box>
  );
}

export default Footer;
